import { AppDrawerContent } from '../../../../../components-v2/Drawer/AppDrawer';
import { ContactInfo } from './ContactInfo';

type Props = {
	contactId: string | null | undefined;
};

export const ContactInfoAppDrawerContent = ({ contactId }: Props) => {
	return (
		<AppDrawerContent value='contact-info'>
			<ContactInfo contactId={contactId} />
		</AppDrawerContent>
	);
};
